import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { trackFunnel } from "@/lib/analytics";
import { useOnboardingStore } from "@/stores/onboarding";

export const Route = createFileRoute("/onboarding/contacts")({
  component: ContactsStep,
});

function ContactsStep() {
  const navigate = useNavigate();
  const contacts = useOnboardingStore((s) => s.trustedContacts);
  const setTrustedContacts = useOnboardingStore((s) => s.setTrustedContacts);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  function add() {
    if (!name || !phone || contacts.length >= 3) return;
    setTrustedContacts([...contacts, { name, phone }]);
    setName("");
    setPhone("");
  }

  return (
    <div className="flex flex-1 flex-col">
      <h1 className="font-display text-3xl font-bold">Trusted contacts</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Optional. Each contact must opt in by SMS reply before receiving anything. Max 3.
      </p>

      <div className="mt-6 space-y-3">
        <Input placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
        <Input placeholder="+2547…" value={phone} onChange={(e) => setPhone(e.target.value)} />
        <Button
          type="button"
          variant="secondary"
          className="w-full"
          onClick={add}
          disabled={contacts.length >= 3}
        >
          <Plus className="h-4 w-4" /> Add contact
        </Button>
      </div>

      <div className="mt-4 space-y-2">
        {contacts.map((c, i) => (
          <div
            key={`${c.phone}-${i}`}
            className="flex items-center justify-between rounded-md border border-border px-3 py-2"
          >
            <div>
              <p className="text-sm font-semibold">{c.name}</p>
              <p className="text-xs text-muted-foreground">{c.phone}</p>
            </div>
            <Button
              size="icon"
              variant="ghost"
              aria-label="Remove"
              onClick={() => setTrustedContacts(contacts.filter((_, idx) => idx !== i))}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>

      <div className="mt-auto space-y-2 pt-8">
        <Button
          className="w-full"
          onClick={() => {
            trackFunnel("step_completed", "contacts");
            void navigate({ to: "/onboarding/enable" });
          }}
        >
          Continue
        </Button>
        <Button
          variant="ghost"
          className="w-full"
          onClick={() => {
            trackFunnel("step_skipped", "contacts");
            void navigate({ to: "/onboarding/enable" });
          }}
        >
          Skip
        </Button>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => void navigate({ to: "/onboarding/consent" })}
        >
          Back
        </Button>
      </div>
    </div>
  );
}
